import { render, staticRenderFns } from "./star-rating-wrapper.vue?vue&type=template&id=6ca0b31a"
import script from "./star-rating-wrapper.vue?vue&type=script&lang=js"
export * from "./star-rating-wrapper.vue?vue&type=script&lang=js"
import style0 from "./star-rating-wrapper.vue?vue&type=style&index=0&id=6ca0b31a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports